import {
    getPosts,
    getPost,
    updatePost,
    createPost,
    deletePost
} from '../../api/postsApi'
import {
    getCategories
} from '../../api/categoryApi'
import {
    getTags
} from '../../api/tagsApi'
import {
    createAuthor, deleteAuthor,
    getAuthors
} from '../../api/authorsApi'

import {Message} from "element-ui";
const state = {
    posts: [],
    post: [],
    categories: [],
    tags: [],
    meta: {},
    authors: [],
}

const getters = {
    getPosts: state => state.posts,
    getPost: state => state.post,
    getPostsMeta: state => state.meta,
    getCategories: state => state.categories,
    getTags: state => state.tags,
    getAuthors: state => state.authors
}

const mutations = {
    SET_POSTS: (state, payload) => {
        state.posts = payload.data
        state.meta = payload.meta
    },
    SET_POST: (state, payload) => {
        state.post = payload.data
    },
    SET_CATEGORIES: (state, payload) => {

        state.categories = payload.data
    },
    SET_TAGS: (state, payload) => {
        state.tags = payload.data
    },
    SET_AUTHORS: (state, payload) => {
        state.authors = payload.data
    }
}

const actions = {
    getPosts: ({commit}, params) => {
        getPosts(params).then(resp => {
            commit('SET_POSTS', resp)
        }).catch(err => console.log(err))
    },
    getPost: ({commit}, params) => {
        getPost(params).then(resp => {
            commit('SET_POST', resp)
        }).catch(err => console.log(err))
    },
    getCategories: ({commit}, params) => {
        getCategories(params).then(resp =>{
            commit('SET_CATEGORIES',resp)
        }).catch(err=>console.log(err))
    },
    getTags: ({commit}, params) => {
        getTags(params).then(resp =>{
            commit('SET_TAGS',resp)
        }).catch(err=>console.log(err))
    },
    getAuthors: ({commit}, params) => {
        getAuthors(params).then(resp =>{
            commit('SET_AUTHORS',resp)
        }).catch(err=>console.log(err))
    },
    updatePost: ({commit}, payload) => {
        updatePost(payload).then(r => {
            Message({
                message: 'Data saved',
                type: 'success',
                duration: 5 * 1000,
            })
        }).catch(err => console.dir(err))
    },
    createPost: ({commit}, payload) => {
        createPost(payload).then(r => {
            Message({
                message: 'Data saved',
                type: 'success',
                duration: 5 * 1000,
            })
        }).catch(err => console.dir(err))
    },
    deletePost: ({dispatch}, id) => {
        deletePost(id).then(r => {
            Message({
                message: 'Author has been deleted',
                type: 'success',
                duration: 5 * 1000,
                showClose: true,
            })
        })
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
